// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30avn","inner":"Footer_inner__3iTRB","nextIcon":"Footer_nextIcon__2xZFC","innerLeft":"Footer_innerLeft__2VGOJ"};